import React, { useEffect } from 'react'
import {
  Link,
  useParams,
  useNavigate,
  //  useLocation
} from 'react-router-dom'
import ArrowBackIcon from '@material-ui/icons/ArrowBack'
import { useSelector, useDispatch } from 'react-redux'
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown'
import { makeStyles } from '@material-ui/core/styles'
import {
  Accordion,
  AccordionSummary,
  Typography,
  AccordionDetails,
  Divider,
} from '@material-ui/core'
import PublicCourseHeader from '../publicCourse/PublicCourseHeader'
import PlayIcon from '../../../icons/PlayIcon'
import styles from './Bought.module.css'
import BasketCard from '../professionalCourse/BasketCard'
import {
  getCourse, selectorCourse,
  getcourseVideos,
  selectorCourseVideos,
  selectorCourseGroup, getCourseGroup,
  // getCourseVideo,
  // selectorCourseBasket
} from '../../../app/slices/courseSlice'
import { selectUserInfo } from '../../../app/slices/userSlice'
import { replaceRegN } from '../../../utils/CustomString'

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    color: '#3a455d',
    fontWeight: 600,
  },
  rootAccordIcon: {
    color: '#f9b233',
    fontSize: '35px',
  },
  rootAccord: {
    borderRadius: '15px !important',
  },

  rootAccordSummary: {
    margin: '24px 10px',
  },
  rootAccordDetails: {
    marginTop: '15px',
  },
}))

function BoughtCourseSection({ professional }) {
  const dispatch = useDispatch()
  const classes = useStyles()
  const course = useSelector(selectorCourse)
  const courseVideos = useSelector(selectorCourseVideos)
  const courseGroup = useSelector(selectorCourseGroup)
  // const courseBasket = useSelector(selectorCourseBasket)
  const user = useSelector(selectUserInfo)
  const role = useSelector((state) => state.user?.role)
  const { id } = useParams()
  const navigate = useNavigate()
  let getVideos

  useEffect(() => {
    if (course?.courseGroupId) {
      dispatch(getCourseGroup(+course?.courseGroupId))
    }
    dispatch(getCourse(id))
  }, [course?.courseGroupId])

  useEffect(() => {
    getVideos = setTimeout(() => dispatch(getcourseVideos({
      UserId: user?.userId,
      CourseId: id,
    })), 500)

    return () => {
      clearTimeout(getVideos)
    }
  }, [])

  let courseTime = null
  let courseTimeText = null

  if (course?.videoLength / 60 < 1) {
    courseTime = course?.videoLength.toFixed()
    courseTimeText = 'ثانیه'
  } else if (course?.videoLength / 60 > 1) {
    courseTime = (course?.videoLength / 60).toFixed()
    courseTimeText = 'دقیقه'
  } else if (course?.videoLength / 60 > 60) {
    courseTime = ((course?.videoLength / 60) / 60).toFixed()
    courseTimeText = 'ساعت'
  }

  return (
    <div>
      {[1].includes(role?.roleId) && (
      <PublicCourseHeader expireDate={courseGroup?.expireDate
        ? courseGroup?.expireDate : null}
      />
      )}

      <section className={styles.Professional_course_details_header}>
        <div
          className={styles.Professional_course_details_header_img}
        >
          <img
            src={course?.imageUrl ? course?.imageUrl : `${window.location.origin}/images/row-students-doing-exam_1098-174.jpg`}
            alt="ProfessionalCourse"
            width="100%"
            height="100%"
            className={styles.Professional_course_details_header_img_self}
          />
        </div>
        <div
          className={styles.Professional_course_details_header_body}
        >
          <p
            className={styles.Professional_course_details_header_body_title}
          >

            {course?.title}

          </p>
          <p
            className={styles.Professional_course_details_header_body_desc}
          >
            مدت زمان آموزش های این صفحه:

          </p>
        </div>
        <div
          className={styles.Professional_course_details_header_time}
        >
          <div
            style={{ cursor: 'pointer' }}
            onClick={() => navigate(-1)}
            className={styles.Professional_course_details_header_time_back}
          >
            <p
              className={styles.Professional_course_details_header_time_back_text}
            >
              بازگشت

            </p>
            <p
              className={styles.Professional_course_details_header_time_back_btn}
            >
              <ArrowBackIcon />
            </p>
          </div>
          <p
            className={styles.Professional_course_details_header_time_hour_lession}
          >
            {courseTime}
            {' '}
            {courseTimeText}
          </p>
        </div>
      </section>

      {course?.info && (
        <section
          className={styles.Professional_course_details_body}
        >

          {course?.info
        && (
        <section
          className={styles.Professional_course_details_body_details}
        >
          {course?.info?.map((item) => (

            <div style={{ margin: '5px 0' }}>
              <p
                className={styles.Professional_course_details_body_teacher_title}
              >
                {item?.title}

              </p>

              {item?.description?.includes('\n') ? (
                <p
                  dangerouslySetInnerHTML={{
                    __html: replaceRegN(item?.description),
                  }}
                  className={styles.Professional_course_details_body_desc}
                />
              ) : (
                <p
                  className={styles.Professional_course_details_body_desc}
                >
                  {item?.description}
                </p>
              )}
            </div>

          ))}
        </section>
        )}

          {course?.teacher && (
          <div>
            <span
              className={styles.Professional_course_details_body_teacher_title}
            >
              معرفی مدرس این آموزش:
            </span>
            <div
              className={styles.Professional_course_details_body_teacher_container2}
            >

              <div
                className={styles.Professional_course_details_body_teacher_wrap}
              >
                <div
                  className={styles.Professional_course_details_body_img_wrap}
                >
                  <div
                    className={styles.Professional_course_details_body_img}
                  >
                    <img
                      src={course?.teacher?.imageUrl ? course?.teacher?.imageUrl : `${window.location.origin}/images/row-students-doing-exam_1098-174.jpg`}
                      alt="ProfessionalCourse"
                      className={styles.Professional_course_details_body_teacher_img}
                    />
                  </div>
                  <span
                    className={styles.Professional_course_details_teacherName}
                  >
                    {course?.teacher?.name}
                  </span>
                </div>

              </div>
              <div
                className={styles.Professional_course_details_about_teacher_wrap}
              >
                <span
                  className={styles.Professional_course_details_about_teacher_title}
                >
                  درباره
                  {' '}
                  {course?.teacher?.name}
                </span>
                <span
                  className={styles.Professional_course_details_about_teacher_desc}
                >
                  {course?.teacher?.description}
                </span>
              </div>
            </div>
          </div>
          )}

        </section>

      )}

      {professional ? (
        <section
          className={styles.Professional_course_details_headlines}
        >
          <Accordion
            classes={{ root: classes.rootAccord }}
          >
            <AccordionSummary
              classes={{ content: classes.rootAccordSummary }}
              expandIcon={(
                <ArrowDropDownIcon
                  classes={{ root: classes.rootAccordIcon }}
                />
          )}
              aria-controls="panel1a-content"
              id="panel1a-header"
            >
              <Typography className={classes.heading}>
                سرفصل ها

              </Typography>
            </AccordionSummary>
            <Divider
              style={{ width: '95%', margin: '0 auto' }}
            />
            <AccordionDetails
              classes={{ root: classes.rootAccordDetails }}
            >
              <div
                className={styles.Professional_course_details_videoWrap}
              >
                <div
                  style={{
                    display: 'flex', flexFlow: 'row', justifyContent: 'space-between', width: '100%',
                  }}
                >
                  <div
                    className={styles.Professional_course_details_videoIcon}
                  >
                    <PlayIcon />
                    <span
                      style={{
                        color: '#3a455d',
                        fontSize: '15px',
                        fontWeight: '600',
                        marginRight: '10px',
                      }}
                    >
                      درس اول

                    </span>
                  </div>

                  <span
                    style={{ color: '#3a455d', fontSize: '16px', fontWeight: '600' }}
                  >
                    ۲۰۰ ساعت

                  </span>
                </div>

                <Divider
                  style={{ width: '98%', margin: '20px auto' }}
                />
                <div
                  style={{
                    display: 'flex',
                    flexFlow: 'row',
                    justifyContent: 'space-between',
                    width: '100%',
                    margin: '10px 0',
                  }}
                >
                  <div
                    className={styles.Professional_course_details_videoIcon}
                  >
                    <PlayIcon />
                    <span
                      style={{
                        color: '#3a455d',
                        fontSize: '15px',
                        fontWeight: '600',
                        marginRight: '10px',
                      }}
                    >
                      درس اول

                    </span>
                  </div>

                  <span
                    style={{ color: '#3a455d', fontSize: '16px', fontWeight: '600' }}
                  >
                    ۲۰۰ ساعت
                  </span>
                </div>
              </div>

            </AccordionDetails>

          </Accordion>
        </section>
      ) : (
        <div
          style={{
            display: 'flex', flexFlow: 'row', width: '101%', flexWrap: 'wrap', flexGrow: 1,
          }}
        >
          {courseVideos?.map((video) => {
            const episodeId = video?.id
            const route = ['episode', episodeId].join('/')

            console.log(555555535345, video)

            return (

              <Link
                style={{
                  width: '32.3%',
                  display: 'flex',
                  margin: '0 0 20px 11px',
                }}
                to={route}
                // onClick={dispatch(getCourseVideo(episodeId))}
              >
                <BasketCard video={video} course={course} bought />
              </Link>
            )
          })}
        </div>
      )}

    </div>
  )
}

export default BoughtCourseSection
